import type { FaireProductEntity } from "../../entity_types/product";

export const p_z6wyf5tx3a: FaireProductEntity = {
  token: "p_z6wyf5tx3a",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Cinder",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/49c0f0fe8e20217351883ecbc8ad4f90489838f3fbb53f0d3f67ee1c38c3c25a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/17d54f7c6a6692b7d5f530e0305b951e10d40a4c03edf4dea88978f5c29b82d1.jpeg",
    "https://cdn.faire.com/fastly/b5e9b65652576024f2f4b3e10e06c7c4c11554420652f0029665b7102671b4f8.jpeg",
    "https://cdn.faire.com/fastly/a886897c35bd9bc7d95154a261ce1c2dac71c10316f025721c87e1ca8a39d426.jpeg",
    "https://cdn.faire.com/fastly/8b571b45e2e45e17578af42346d47732488c41e11b8bf08b6f305504c760733d.jpeg",
    "https://cdn.faire.com/fastly/86e5188e39b56c44f9d7e0dd847be060568fd763580000706a955cba18cc7c00.jpeg",
    "https://cdn.faire.com/fastly/897bca10aebd0bb4e1df9861b14b08e3f37fad6edf3996d76d9cbe1aec99786f.jpeg",
    "https://cdn.faire.com/fastly/6d3ebd57b197dcdc3fdd36ba102ac79ec9fd778cfed0404c3aeac930b80bc07b.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:24.645Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
